import { css, keyframes, styled } from 'styled-components';

const gradientMotion = keyframes`
0% {
  background-position: 10% 50%;
}
50% {
  background-position: 90% 50%;
}
100% {
  background-position: 10% 50%;
}
`;

const circleMotion = keyframes`
0% {
  transform: translate(0%, -100%) scale(0.7);
}
50% {
  transform: translate(100%, 0%) scale(1);
}
100% {
  transform: translate(0%, -100%) scale(0.7);
}
`;

export const StyledButtonGradientBackground = styled.div<{
  $isDisabled: boolean;
  $isHovered: boolean;
}>`
  ${({ $isDisabled, $isHovered, theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    z-index: -1;
    background-image: linear-gradient(
      117.09deg,
      #222834 -5%,
      #6a57e3 10%,
      #cd74dd 50%,
      #6a57e3 90%,
      #222834 105%
    );
    background-size: 400% 400%;
    animation: ${gradientMotion} 6s ease 0s infinite;
    opacity: ${!$isDisabled && $isHovered ? 1 : 0};
    transition: opacity 0.2s ease-in-out;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      paddin-top: 30%;
      right: 0;
      bottom: 0;
      border-radius: 100%;
      z-index: 0;
      background-color: ${theme.colorsV2.white};
      animation: ${circleMotion} 6s ease 0s infinite;
      mix-blend-mode: luminosity;
      opacity: 0.5;
      filter: blur(20px);
    }
  `}
`;

export const StyledButtonGradientBackgroundContraPro = styled.div<{
  $isDisabled: boolean;
  $isHovered: boolean;
}>`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    z-index: -1;
    background-image: linear-gradient(
      90deg,
      rgba(243, 202, 77, 1) 0%,
      rgba(255, 152, 154, 1) 32.88%,
      rgba(203, 171, 255, 1) 94.62%
    );
    background-size: 100% 100%;
    animation: ${gradientMotion} 6s ease 0s infinite;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      padding-top: 30%;
      right: 0;
      bottom: 0;
      border-radius: 100%;
      z-index: 0;
      background-color: ${theme.colorsV2.gray80};
      animation: ${circleMotion} 6s ease 0s infinite;
      mix-blend-mode: luminosity;
      opacity: 0.3;
      filter: blur(20px);
    }
  `}
`;
